var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.price !== null)?_c('span',[_vm._v(" "+_vm._s(_vm._f("toEuro")(_vm.price)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }